// ============================================================
// M&L Cart Helpers — shared across all mandl-quick-add instances
// ============================================================

function mandlUpdateBadge(count) {
  const badge = document.getElementById('mandl-cart-badge');
  if (!badge) return;
  badge.hidden = count === 0;
  const numEl = badge.querySelector('[aria-hidden]');
  if (numEl) numEl.textContent = count < 100 ? count : '99+';
}

function mandlFormatMoney(cents) {
  const currency =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
  } catch {
    return '$' + (cents / 100).toFixed(2);
  }
}

function mandlShowCartPopup(productName, subtotalCents) {
  const popup = document.getElementById('mandl-cart-popup');
  if (!popup) return;
  const nameEl = popup.querySelector('.mandl-cart-popup__name');
  const totalEl = popup.querySelector('.mandl-cart-popup__total');
  if (nameEl) nameEl.textContent = productName;
  if (totalEl) totalEl.textContent = mandlFormatMoney(subtotalCents);
  popup.classList.add('is-visible');
  clearTimeout(popup._dismissTimer);
  popup._dismissTimer = setTimeout(mandlHideCartPopup, 4000);
}

function mandlHideCartPopup() {
  const popup = document.getElementById('mandl-cart-popup');
  if (popup) popup.classList.remove('is-visible');
}

// On page load: sync badge with real cart state + wire up popup close buttons
document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((cart) => mandlUpdateBadge(cart.item_count))
    .catch(() => {});

  const popup = document.getElementById('mandl-cart-popup');
  if (popup) {
    popup.querySelector('.mandl-cart-popup__close')?.addEventListener('click', mandlHideCartPopup);
    popup
      .querySelector('.mandl-cart-popup__btn--secondary')
      ?.addEventListener('click', mandlHideCartPopup);
  }
});

// ============================================================
// mandl-quick-add Web Component
// ============================================================

if (!customElements.get('mandl-quick-add')) {
  customElements.define(
    'mandl-quick-add',
    class MandlQuickAdd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.mandl-hover-btn');
        if (!this.button) return;

        // Variant select — present on multi-variant strip cards
        const select = this.querySelector('.mandl-strip__variant-select');
        if (select) {
          select.addEventListener('change', () => this.onVariantChange(select));
        }

        this.button.addEventListener('click', this.onButtonClick.bind(this));
      }

      onVariantChange(select) {
        const opt = select.options[select.selectedIndex];
        this.button.disabled = opt ? opt.disabled : false;
      }

      onButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const select = this.querySelector('.mandl-strip__variant-select');
        const variantId = select ? select.value : this.dataset.variantId;
        if (!variantId) return;

        const productTitle = this.dataset.productTitle || '';

        this.setLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then((response) => {
            if (!response.ok) return response.json().then((err) => Promise.reject(err));
            return response.json();
          })
          .then((item) => {
            this.setLoading(false);
            this.setSuccess();
            this.refreshCartCount(item.title || productTitle);
          })
          .catch(() => {
            this.setLoading(false);
            const link = this.closest('.card-wrapper')?.querySelector('a.full-unstyled-link');
            if (link) window.location = link.href;
          });
      }

      setLoading(state) {
        this.button.disabled = state;
        this.button.classList.toggle('mandl-hover-btn--loading', state);
      }

      setSuccess() {
        this.button.classList.add('mandl-hover-btn--success');
        const label = this.button.querySelector('.mandl-hover-btn__label');
        const check = this.button.querySelector('.mandl-hover-btn__check');
        if (label) label.hidden = true;
        if (check) check.hidden = false;

        setTimeout(() => {
          this.button.classList.remove('mandl-hover-btn--success');
          if (label) label.hidden = false;
          if (check) check.hidden = true;
          this.button.disabled = false;
        }, 2000);
      }

      refreshCartCount(productTitle) {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            mandlUpdateBadge(cart.item_count);
            mandlShowCartPopup(productTitle, cart.items_subtotal_price);
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { cart });
            }
          })
          .catch(() => {});
      }
    }
  );
}
